// extracted by mini-css-extract-plugin
export default {"Header":"AhgF1t8RzmSaXG9oCU2O"};